export const data = [
  { name: 'Milk', quantity: 4 },
  { name: 'Butter Chapati', quantity: 15 },
  { name: 'Rice', quantity: 50 }
];
